<template>
    <div>
        <!-- 弹出框修改 -->
        <el-dialog :title='dialogTitle' :visible.sync='showDialogVisible' width='56%' :before-close='dialogClose'>
            <el-form ref='dialogfrom' :rules='rules' :model='addForm' label-width='172px' size='mini'
                :disabled="dialogTitle === '查看'">
                <div v-if="dialogTitle === '新增' || dialogTitle === '修改' || dialogTitle === '查看'">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label='设备类型:' prop="equipmentTypeId">
                                <el-select v-model='addForm.equipmentTypeId' placeholder='请选择' style="width:100%">
                                    <el-option v-for="(item, index) in typeList" :key="index" :label="item.dictLabel"
                                        :value="item.dictCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label='设备品牌:' prop="equipmentBrandId">
                                <el-select v-model='addForm.equipmentBrandId' placeholder='请选择' style="width:100%">
                                    <el-option v-for="(item, index) in brandList" :key="index" :label="item.dictLabel"
                                        :value="item.dictCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label='设备名称:' prop='equipmentName'>
                                <el-input v-model='addForm.equipmentName' placeholder='请输入'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label='设备编码:' prop='equipmentNumber'>
                                <el-input type='text' v-model='addForm.equipmentNumber' placeholder='请输入'></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label='设备ID:' prop='deviceId'>
                                <el-input v-model='addForm.deviceId' placeholder='请输入'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label='设备版本:' prop='networkType'>
                                <el-select v-model='addForm.networkType' placeholder='请选择' style="width:100%">
                                    <el-option v-for="(item, index) in versonList" :key="index" :label="item"
                                        :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="18">
                            <el-form-item label='设备位置:' prop='equipmentAddress'>
                                <el-input type='text' v-model='addForm.equipmentAddress' placeholder='请输入'></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <!-- 以下是睡眠设备 addForm.equipmentTypeId == 715 &&-->
                <div v-if="equipId == 715 && dialogTitle === '设置'">
                    <!-- 睡眠记录时间 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="记录睡眠开始时间:" prop="recordSt">
                                <el-time-picker v-model="addForm.recordSt" value-format="HH:mm" format="HH:mm"
                                    placeholder="请输入记录睡眠开始时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="记录睡眠结束时间:" prop="recordEd">
                                <el-time-picker v-model="addForm.recordEd" value-format="HH:mm" format="HH:mm"
                                    placeholder="请输入记录睡眠结束时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 心率单独预警时间 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="心率预警开始时间:" prop="hrWarnStart">
                                <el-time-picker v-model="addForm.hrWarnStart" value-format="HH:mm" format="HH:mm"
                                    placeholder="请输入心率预警开始时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="心率预警结束时间:" prop="hrWarnEnd">
                                <el-time-picker v-model="addForm.hrWarnEnd" value-format="HH:mm" format="HH:mm"
                                    placeholder="请输入心率预警结束时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 呼吸率单独预警时间 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="呼吸率预警开始时间:" prop="brWarnStart">
                                <el-time-picker v-model="addForm.brWarnStart" value-format="HH:mm" format="HH:mm"
                                    placeholder="请输入呼吸率预警开始时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="呼吸率预警结束时间:" prop="brWarnEnd">
                                <el-time-picker v-model="addForm.brWarnEnd" value-format="HH:mm" format="HH:mm"
                                    placeholder="请输入呼吸率预警结束时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 离床单独预警时间 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="离床预警开始时间:" prop="offbedWarnStart">
                                <el-time-picker v-model="addForm.offbedWarnStart" value-format="HH:mm" format="HH:mm"
                                    placeholder="请输入离床预警开始时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="离床预警结束时间:" prop="offbedWarnEnd">
                                <el-time-picker v-model="addForm.offbedWarnEnd" value-format="HH:mm" format="HH:mm"
                                    placeholder="请输入离床预警结束时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 指标统一预警时间 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="指标统一的预警开始时间:" prop="warnSt">
                                <el-time-picker v-model="addForm.warnSt" value-format="HH:mm" format="HH:mm"
                                    placeholder="请输入指标统一的预警开始时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="指标统一的预警结束时间:" prop="warnEd">
                                <el-time-picker v-model="addForm.warnEd" value-format="HH:mm" format="HH:mm"
                                    placeholder="请输入指标统一的预警结束时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 全天预警开关 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="心率预警:" prop="hrAllDay">
                                <el-select v-model="addForm.hrAllDay" style="width: 100%;">
                                    <el-option value="1" label="心率一项全天预警" />
                                    <el-option value="0" label="按之前设置的起止时间预警" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="呼吸率:" prop="brAllDay">
                                <el-select v-model="addForm.brAllDay" style="width: 100%;">
                                    <el-option value="1" label="呼吸率一项全天预警" />
                                    <el-option value="0" label="按之前设置的起止时间预警" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="离床预警:" prop="offbedAllDay">
                                <el-select v-model="addForm.offbedAllDay" style="width: 100%;">
                                    <el-option value="1" label="离床一项全天预警" />
                                    <el-option value="0" label="按之前设置的起止时间预警" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="子类指标都全天预警:" prop="allDay">
                                <el-select v-model="addForm.allDay" style="width: 100%;">
                                    <el-option value="1" label="子类指标都全天预警一项全天预警" />
                                    <el-option value="0" label="按之前设置的起止时间预警" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 预警间隔 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="预警推送最小间隔时间:" prop="interval">
                                <el-input type="number" v-model="addForm.interval" placeholder="请输入"
                                    style="width: 100%;" />
                                <template #append>分钟</template>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否开启离床过久预警:" prop="offbedSwitch">
                                <el-select v-model="addForm.offbedSwitch" style="width: 100%;">
                                    <el-option value="1" label="是" />
                                    <el-option value="0" label="否" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 离床阈值 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="离床过久的报警阈值:" prop="offbedThre">
                                <el-input type="number" v-model="addForm.offbedThre" placeholder="请输入"
                                    style="width: 100%;" />
                                <template #append>分钟</template>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否开启心率超限预警:" prop="hrSwitch">
                                <el-select v-model="addForm.hrSwitch" style="width: 100%;">
                                    <el-option value="1" label="是" />
                                    <el-option value="0" label="否" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 心率上下限 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="预警心率下限:" prop="hrMin">
                                <el-input type="number" v-model="addForm.hrMin" placeholder="请输入"
                                    style="width: 100%;" />
                                <template #append>次/分钟</template>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="预警心率上限:" prop="hrMax">
                                <el-input type="number" v-model="addForm.hrMax" placeholder="请输入"
                                    style="width: 100%;" />
                                <template #append>次/分钟</template>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="预警呼吸率下限:" prop="brMin">
                                <el-input type="number" v-model="addForm.brMin" placeholder="请输入"
                                    style="width: 100%;" />
                                <template #append>次/分钟</template>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="预警呼吸率上限:" prop="brMax">
                                <el-input type="number" v-model="addForm.brMax" placeholder="请输入"
                                    style="width: 100%;" />
                                <template #append>次/分钟</template>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 呼吸率开关与上下限 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="是否开启呼吸超限预警:" prop="brSwitch">
                                <el-select v-model="addForm.brSwitch" style="width: 100%;">
                                    <el-option value="1" label="是" />
                                    <el-option value="0" label="否" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="呼吸预警是否平台告警:" prop="brPopUp">
                               <el-select v-model="addForm.brPopUp" style="width: 100%;">
                                    <el-option value="1" label="是" />
                                    <el-option value="0" label="否" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                      <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="离床预警是否平台告警:" prop="offbedPopUp">
                                <el-select v-model="addForm.offbedPopUp" style="width: 100%;">
                                    <el-option value="1" label="是" />
                                    <el-option value="0" label="否" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="心率警是否平台告警:" prop="hrPopUp">
                               <el-select v-model="addForm.hrPopUp" style="width: 100%;">
                                    <el-option value="1" label="是" />
                                    <el-option value="0" label="否" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                   
                </div>
                <!-- 以下是跌倒设备 -->
                <div v-if="equipId == 716 && dialogTitle === '设置'">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="雷达安装高度 (1~5):" prop="height">
                                <el-input-number v-model="addForm.height" :min="1" :max="5" :precision="1"
                                    controls-position="right" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="灵敏度 (2~10):" prop="sensitivity">
                                <el-input-number v-model="addForm.sensitivity" :min="2" :max="10"
                                    controls-position="right" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 布防时间 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="布防开始时间:" prop="defenseStartTime">
                                <el-time-picker v-model="addForm.defenseStartTime" value-format="HH:mm" format="HH:mm"
                                    placeholder="请选择时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="布防结束时间:" prop="defenseStopTime">
                                <el-time-picker v-model="addForm.defenseStopTime" value-format="HH:mm" format="HH:mm"
                                    placeholder="请选择时间" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 开关类字段 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="安装方式:" prop="mountType">
                                <el-select v-model="addForm.mountType" placeholder="请选择" style="width: 100%;">
                                    <el-option label="顶装" value="0" />
                                    <el-option label="侧装" value="1" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="灯光开关:" prop="lightSwitch">
                                <el-switch v-model="addForm.lightSwitch" :active-value="'1'" :inactive-value="'0'" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="驻留预警开关:" prop="stayAlert">
                                <el-switch v-model="addForm.stayAlert" :active-value="'1'" :inactive-value="'0'" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="无人预警开关:" prop="noPeopleAlert">
                                <el-switch v-model="addForm.noPeopleAlert" :active-value="'1'" :inactive-value="'0'" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="跌倒预警开关:" prop="fallAlert">
                                <el-switch v-model="addForm.fallAlert" :active-value="'1'" :inactive-value="'0'" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="布防开关:" prop="defenseSwitch">
                                <el-switch v-model="addForm.defenseSwitch" :active-value="'1'" :inactive-value="'0'" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="跌倒阈值 (0~1):" prop="threshold">
                                <el-input-number v-model="addForm.threshold" :min="0" :max="1" :step="0.1"
                                    :precision="2" controls-position="right" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="上报时间频率 (秒):" prop="updateTime">
                                <el-input-number v-model="addForm.updateTime" :min="1" controls-position="right"
                                    style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="驻留预警时间 (秒):" prop="stayTime">
                                <el-input-number v-model="addForm.stayTime" :min="0" controls-position="right"
                                    style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="无人预警时间 (秒):" prop="noPeopleTime">
                                <el-input-number v-model="addForm.noPeopleTime" :min="0" controls-position="right"
                                    style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 坐标与检测范围 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="跌倒坐标 X (-3~3):" prop="fallX">
                                <el-input-number v-model="addForm.fallX" :min="-3" :max="3" :step="0.1" :precision="2"
                                    controls-position="right" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="跌倒坐标 Y (-3~3):" prop="fallY">
                                <el-input-number v-model="addForm.fallY" :min="-3" :max="3" :step="0.1" :precision="2"
                                    controls-position="right" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Y轴左半轴范围 (0.3~1.6):" prop="zf">
                                <el-input-number v-model="addForm.zf" :min="0.3" :max="1.6" :step="0.1" :precision="2"
                                    controls-position="right" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Y轴右半轴范围 (0.3~1.6):" prop="zb">
                                <el-input-number v-model="addForm.zb" :min="0.3" :max="1.6" :step="0.1" :precision="2"
                                    controls-position="right" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="X轴右半轴范围 (0.3~1.6):" prop="xr">
                                <el-input-number v-model="addForm.xr" :min="0.3" :max="1.6" :step="0.1" :precision="2"
                                    controls-position="right" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="X轴左半轴范围 (0.3~1.6):" prop="xl">
                                <el-input-number v-model="addForm.xl" :min="0.3" :max="1.6" :step="0.1" :precision="2"
                                    controls-position="right" style="width: 100%;" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 其他文本字段（如设备信息） -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="设备名称:" prop="nickName">
                                <el-input v-model="addForm.nickName" placeholder="请输入" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="上报方式:" prop="reportType">
                                <el-select v-model="addForm.reportType" placeholder="请选择" style="width: 100%;">
                                    <el-option label="状态上报" value="0" />
                                    <el-option label="定时上报" value="1" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                  
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="跌倒预警是否平台告警:" prop="fallPopUp">
                                 <el-select v-model="addForm.fallPopUp" style="width: 100%;">
                                    <el-option value="1" label="是" />
                                    <el-option value="0" label="否" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <div class='boontbtn'>
                <el-button v-if="dialogTitle !== '查看'" type='primary' size='small' style='margin: 0 30px' @click='send'>
                    确定
                </el-button>
                <el-button type='info' size='small' @click='dialogClose'>关闭
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { post } from '@/api/requrestHttp'
export default {
    props: ['dialogTitle', 'showDialogVisible', 'typeList', 'brandList'],
    components: {

    },
    data() {
        return {
            addForm: {},
            rules: {
                equipmentTypeId: [
                    {
                        required: true,
                        message: '请输入设备类型',
                        trigger: 'change'
                    }
                ],
                equipmentBrandId: [
                    {
                        required: true,
                        message: '请输入设备品牌',
                        trigger: 'change'
                    }
                ],
                equipmentName: [
                    { required: true, message: '请输入设备名称', trigger: 'blur' }
                ],
                equipmentNumber: [
                    { required: true, message: '请输入设备编码', trigger: 'blur' }
                ],
                equipmentAddress: [
                    { required: true, message: '请输入设备位置', trigger: 'blur' }
                ],
                deviceId: [
                    { required: true, message: '请输入设备ID', trigger: 'blur' }
                ],
                networkType: [
                    { required: true, message: '请输入设备版本', trigger: 'change' }
                ],
            },
            equipId: '',
            id: '',
            versonList: ['X2', 'L4P', 'SLEEP_X2', 'SLEEP_X2LTE', 'SLEEP_L4P', 'SLEEP_L4PLTE']
        }
    },
    methods: {
        async seeDialog(type, id, equipmentTypeId) {
            this.id = id
            this.equipId = equipmentTypeId
            let res = {}
            if (type == '查看' || type == '修改') {
                res = await post('/ypt/admin/equipment/info/getById', { id: id })
            } else {
                if (equipmentTypeId == 715) {  //睡眠设备
                    res = await post('/ypt/admin/equipment/sleepSet/getByEquipmentId', { equipmentId: id })
                } else if (equipmentTypeId == 716) {  //跌倒设备
                    res = await post('/ypt/admin/equipment/fallSet/getByEquipmentId', { equipmentId: id })
                }
            }
            if (res.content != null) {
                this.addForm = res.content
            }
        },
        async send() {
            this.$refs.dialogfrom.validate(async (valid) => {
                if (valid) {
                    let url
                    if (this.dialogTitle === '新增') {
                        url = '/ypt/admin/equipment/info/insert'
                    }
                    if (this.dialogTitle === '修改') {
                        url = '/ypt/admin/equipment/info/update'
                    }
                    console.log(this.addForm.equipmentTypeId, this.dialogTitle, '====')
                    if (this.equipId == 715 && this.dialogTitle === '设置') {
                        url = 'ypt/admin/equipment/sleepSet/insertOrUpdate' //   睡眠
                        this.addForm.equipmentId = this.id
                    } else if (this.equipId == 716 && this.dialogTitle === '设置') {
                        url = 'ypt/admin/equipment/fallSet/insertOrUpdate' //   跌倒
                        this.addForm.equipmentId = this.id
                    }
                    this.addForm.status = '0'
                    const res = await post(url, this.addForm)
                    this.dialogClose()
                }
            })
        },
        dialogClose() {
            this.addForm = {}
            this.$refs.dialogfrom.resetFields()
            this.$emit('disClose')
        },
    }
}
</script>
<style></style>